"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeStore = void 0;
var _reduxThunk = require("redux-thunk");
var _toolkit = require("@reduxjs/toolkit");
var _userSlice = _interopRequireDefault(require("./features/user/userSlice"));
var _appConfigurationSlice = _interopRequireDefault(require("./features/appConfiguration/appConfigurationSlice"));
var _paymentMethodsSlice = _interopRequireDefault(require("./features/paymentMethods/paymentMethodsSlice"));
var _shippingMethodsSlice = _interopRequireDefault(require("./features/shippingMethods/shippingMethodsSlice"));
var _checkoutDataSlice = _interopRequireDefault(require("./features/checkoutData/checkoutDataSlice"));
var _countriesShippingSlice = _interopRequireDefault(require("./features/countriesShipping/countriesShippingSlice"));
var makeStore = function makeStore(context) {
  return (0, _toolkit.configureStore)({
    reducer: {
      user: _userSlice["default"],
      paymentMethods: _paymentMethodsSlice["default"],
      appConfiguration: _appConfigurationSlice["default"],
      shippingMethods: _shippingMethodsSlice["default"],
      checkoutData: _checkoutDataSlice["default"],
      countriesShipping: _countriesShippingSlice["default"]
    },
    middleware: function middleware() {
      return [_reduxThunk.thunk];
    }
  });
};
exports.makeStore = makeStore;